import React, { useEffect, useState } from "react";
import "./adminPanel.css"; // Reuse some grid styles if needed, but we'll focus on stats
import { API_BASE_URL } from "../config";

const StatCard = ({ title, value, icon, color, loading }) => (
  <div className="admin-card-elite" style={{ "--accent": color, cursor: 'default' }}>
    <div className="ac-icon-box" style={{ background: `${color}15`, color: color }}>{icon}</div>
    <div className="ac-details">
      <p style={{ margin: 0, fontSize: '0.75rem', fontWeight: 800, textTransform: 'uppercase', color: '#64748b' }}>{title}</p>
      <h3 style={{ fontSize: '1.8rem', margin: '5px 0' }}>{loading ? "..." : value}</h3>
      <div style={{ fontSize: '0.7rem', color: '#10b981', fontWeight: 700 }}>
        Optimal Load
      </div>
    </div>
  </div>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    courses: 0,
    certificates: 0,
    enrollments: 0,
    messages: 0,
  });
  const [recentActivity, setRecentActivity] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDynamicData = async () => {
      try {
        setLoading(true);
        const adminInfo = JSON.parse(localStorage.getItem("adminInfo") || "{}");
        const token = adminInfo?.token;
        const options = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

        // Fetch all operational vectors in parallel
        const [
          resCourses,
          resCerts,
          resEnroll,
          resMessages
        ] = await Promise.allSettled([
          fetch(`${API_BASE_URL}/api/courses`),
          fetch(`${API_BASE_URL}/api/certificates`, options),
          fetch(`${API_BASE_URL}/api/enrollments`, options),
          fetch(`${API_BASE_URL}/home/admin/getTouch`, options)
        ]);

        const dataCourses = resCourses.status === "fulfilled" && resCourses.value.ok ? await resCourses.value.json() : [];
        const dataCerts = resCerts.status === "fulfilled" && resCerts.value.ok ? await resCerts.value.json() : [];
        const dataEnroll = resEnroll.status === "fulfilled" && resEnroll.value.ok ? await resEnroll.value.json() : [];
        let rawMessages = [];
        if (resMessages.status === "fulfilled" && resMessages.value.ok) {
           const msgData = await resMessages.value.json();
           rawMessages = msgData.data || msgData || [];
        }

        const normCourses = Array.isArray(dataCourses) ? dataCourses : [];
        const normCerts = Array.isArray(dataCerts) ? dataCerts : [];
        const normEnroll = Array.isArray(dataEnroll) ? dataEnroll : [];
        const normMessages = Array.isArray(rawMessages) ? rawMessages : [];

        // Compile counts
        setStats({
          courses: normCourses.length,
          certificates: normCerts.length,
          enrollments: normEnroll.length,
          messages: normMessages.length
        });

        // Construct synthetic recent activity based on the actual items detected
        const combined = [];
        
        // Take the latest element of each
        if (normCourses.length > 0) combined.push({ type: "Curriculum Sync", subject: normCourses[normCourses.length - 1].name || "New Course Deployed", tag: "success" });
        if (normEnroll.length > 0) combined.push({ type: "Registry Auth", subject: `Enrollment: ${normEnroll[normEnroll.length - 1].name || "Candidate"}`, tag: "success" });
        if (normMessages.length > 0) combined.push({ type: "Inbound Support", subject: `Comms: ${normMessages[normMessages.length - 1].name || "User"}`, tag: "warning" });
        if (normCerts.length > 0) combined.push({ type: "Credential Issue", subject: `Cert ID: ${normCerts[normCerts.length - 1].certificateId || "N/A"}`, tag: "success" });

        // Generate synthetic times to make UI realistic
        setRecentActivity(combined.slice(0, 5));
      } catch (e) {
        console.error("Dashboard Dynamic Sync Failed:", e);
      } finally {
        setLoading(false);
      }
    };

    fetchDynamicData();
  }, []);

  return (
    <div className="admin-main-content">
      <div className="ap-welcome">
        <h1>Operational Overview</h1>
        <p>Real-time telemetry and mission-critical metrics for the FlyTutor ecosystem.</p>
      </div>

      <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
        <StatCard title="Total Courses" value={stats.courses} icon="📚" color="#6366f1" loading={loading} />
        <StatCard title="Certificates Issued" value={stats.certificates} icon="📜" color="#8b5cf6" loading={loading} />
        <StatCard title="Student Enrollments" value={stats.enrollments} icon="✍️" color="#f43f5e" loading={loading} />
        <StatCard title="Support Inquiries" value={stats.messages} icon="📧" color="#f59e0b" loading={loading} />
      </div>

      <div style={{ marginTop: '40px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: '20px' }}>Recent Activity Stream</h2>
        <div className="admin-table-wrapper">
          <table className="elite-table">
            <thead>
              <tr>
                <th>Event Type</th>
                <th>Subject Context</th>
                <th>Status Node</th>
              </tr>
            </thead>
            <tbody>
              {recentActivity.length === 0 ? (
                 <tr><td colSpan="3" style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>{loading ? "Aggregating Telemetry..." : "No recent events logged in node buffer."}</td></tr>
              ) : (
                recentActivity.map((act, i) => (
                  <tr key={i}>
                    <td><div style={{ fontWeight: 600 }}>{act.type}</div></td>
                    <td>{act.subject}</td>
                    <td><span className={`status-tag ${act.tag === 'success' ? 'status-new' : 'status-contacted'}`}>{act.tag === 'success' ? 'Processed' : 'Action Required'}</span></td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
